<template>
    <div>
        <div class="com-model">
            <div class="top-bar flex  m-b-24">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/index/finance' }">财务管理</el-breadcrumb-item>
                    <el-breadcrumb-item>发票管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="tip">注意：请核实发票信息是否正确</div>
            <div class="" style="width: 420px;padding-bottom: 35px">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-form-item label="发票抬头" prop="invoiceTitle">
                        <el-input v-model="form.invoiceTitle" placeholder="请填写您营业执照上的全称"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记证号" prop="taxNumber">
                        <el-input v-model="form.taxNumber" placeholder="请填写15到20位有效纳税人识别号"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行名称" prop="bankName">
                        <el-input v-model="form.bankName" placeholder="请填写您开户许可证上的开户银行"></el-input>
                    </el-form-item>
                    <el-form-item label="基本开户账号" prop="bankAccountNumber">
                        <el-input v-model="form.bankAccountNumber" placeholder="请填写您开户许可证上的银行账号"></el-input>
                    </el-form-item>
                    <el-form-item label="注册场所地址" prop="registeredAddress">
                        <el-input v-model="form.registeredAddress" placeholder="请填写您营业执照上的注册地址"></el-input>
                    </el-form-item>
                    <el-form-item label="注册固定电话" prop="registeredTel">
                        <el-input v-model="form.registeredTel" placeholder="请填写您公司有效的联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="开票金额" prop="invoiceAmount">
                        <el-input v-model="form.invoiceAmount" type="number" :max="maxInvoiceAmount" placeholder="请填写开票金额"></el-input>
                    </el-form-item>
                    <el-form-item label="接收手机" prop="phone">
                        <el-input v-model="form.phone" placeholder="请填写您接收的手机"></el-input>
                    </el-form-item>
                    <el-form-item label="接收邮箱" prop="email">
                        <el-input v-model="form.email" placeholder="请填写您接收的邮箱地址"></el-input>
                    </el-form-item>
                     <el-form-item >
                        <div class="primary-btn" @click="handleSubmit">提交审核</div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                invoiceTitle: '',
                taxNumber: '',
                bankName: '',
                bankAccountNumber: '',
                registeredAddress: '',
                registeredTel: '',
                invoiceAmount: '',
                phone: '',
                email: ''
            },
            rules: {
                invoiceTitle: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur' }
                ],
                taxNumber: [
                    { required: true, message: '请输入税务登记证号', trigger: 'blur' }
                ],
                invoiceAmount: [
                    { required: true, message: '请输入开票金额', trigger: 'blur' }
                ]
            },
            maxInvoiceAmount: 0
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        getInfo() {
            this.axios.get('/wapi/company/invoice/overview').then(res => {
                if (res.success) {
                    const data = res.data;
                    this.form.invoiceAmount = data.canInvoiceAmount;
                    this.form.invoiceTitle = data.lastInvoiceTitle;
                    this.form.taxNumber = data.lastTaxNumber;
                    this.form.bankName = data.lastBankName;
                    this.form.bankAccountNumber = data.lastBankAccountNumber;
                    this.maxInvoiceAmount = data.canInvoiceAmount;
                    // 如果没有开票信息，获取认证接口的信息
                    if (!this.form.taxNumber || !this.form.invoiceTitle) {
                        this.getAuthInfo()
                    }
                }
            })
        },
        getAuthInfo() {
            this.axios.get('/wapi/company/get').then(res => {
                console.log(res, this.form)
                if(res.success){
                    const data = res.data;
                    if (!this.form.taxNumber) {
                        this.form.taxNumber = data.isAuth ?  data.license : '';
                    }
                    if (!this.form.invoiceTitle) {
                        this.form.invoiceTitle = data.name
                    }
                }
            })
        },
        handleSubmit() {

            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.axios.post('/wapi/company/invoice/create', this.form).then(res => {
                        if (res.success) {
                            this.$message({
                                message: '提交成功',
                                type:'success'
                            });
                            this.$router.go(-1)
                        }
                    })
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.com-model {
    border-radius: 10px;
}
.top-bar{
    padding-left: 24px;
    height: 66px;
    border-bottom: 1px solid #D2D2D2;
}
.tip{
    width: 867px;
    height: 40px;
    line-height: 40px;
    background: #F4F9FF;
    border-radius: 4px;
    border: 1px solid #057CF9;
    font-size: 16px;
    color: #42464B;
    text-align: center;
    margin: 0 auto 35px;
}
</style>



// WEBPACK FOOTER //
// invoiceInfo.vue?093c5156